import React from 'react';
import { Box, Container, Typography, Divider} from '@mui/material';

export default function PrivacyPolicy() {

  return (
    <Box sx={{ bgcolor: '#ffffff', minHeight: '100vh', py: 6 }}>
      <Container maxWidth="md">
        {/* Header */}
        <Typography variant="h3" sx={{ fontWeight: 700, mb: 2, color: '#111827' }}>
          Privacy Policy
        </Typography>
        <Typography variant="body2" sx={{ color: '#6b7280', mb: 4 }}>
          Last Updated: October 2025
        </Typography>

        <Divider sx={{ mb: 4 }} />

        {/* Introduction */}
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          Sniffr.ai ("we", "our", or "us") respects your privacy and is committed to protecting your personal 
          information. This Privacy Policy explains how we collect, use, and safeguard the data you provide 
          through our website, LinkedIn lead forms, and other digital channels.
        </Typography>

        {/* Information We Collect */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          1. Information We Collect
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          We may collect personal information such as your name, email address, job title, company name, 
          and any details you voluntarily provide when requesting a demo, downloading materials, or contacting us.
        </Typography>

        {/* How We Use Your Information */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          2. How We Use Your Information
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 2, lineHeight: 1.8 }}>
          We use your information to:
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8, pl: 3 }}>
          • Provide and personalize our products or services<br />
          • Respond to your inquiries and requests<br />
          • Share product updates, insights, or promotional content related to Sniffr.ai and QDEX Consulting<br />
          • Improve our website, communications, and offerings
        </Typography>

        {/* Data Sharing and Security */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          3. Data Sharing and Security
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          We do not sell, rent, or trade your personal data with third parties. Your information is securely 
          stored and accessed only by authorized personnel for legitimate business purposes.
        </Typography>

        {/* Cookies and Tracking */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          4. Cookies and Tracking
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          Our website may use cookies or analytics tools to understand user behavior and improve user experience. 
          You can adjust your browser settings to decline cookies if preferred.
        </Typography>

        {/* Your Rights */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          5. Your Rights
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          You have the right to request access, correction, or deletion of your personal data. To exercise 
          these rights, please contact us using the details below.
        </Typography>

        {/* Contact */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          6. Contact Us
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 2, lineHeight: 1.8 }}>
          For any questions about this Privacy Policy or our data practices, please contact us at:
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          <strong>Email:</strong> support@sniffr.ai<br />
          <strong>Website:</strong> https://sniffr.ai
        </Typography>

        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8, fontStyle: 'italic' }}>
          Sniffr.ai is a product developed and managed by QDEX Consulting.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="body2" sx={{ color: '#6b7280', textAlign: 'center' }}>
          © 2025 Sniffr.ai. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

